/*
 * @Author: cuixinming
 * @Date: 2024-03-06 13:30:46
 * @Last Modified by: cuixinming
 * @Last Modified time: Do not edit
 * @Description: 
 */
import React, { Fragment } from "react";
import utils from '../../../../../utils/utils';
import Request from "../../../../../utils/request";
import "./style.less";

class PipelineComment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      commentData: {
        all_comment_href: '',
        comment: [],
        dialog_title: '',
        emojis: [],
        has_next: false,
        num: 0,
        num_str: '',
        time: '',
        tips: '',
        user: {
          avatar: '',
          uid: null
        }
      },
      message: ''
    };
    this.pageId = utils.getPageId();
    this.high_light_comment_id = utils.getParams('high_light_comment_id') || '';
    this.high_light_reply_id = utils.getParams('high_light_reply_id') || '';
    this.extra_comment_id = utils.getParams('extra_comment_id') || '';
    this.extra_reply_id = utils.getParams('extra_reply_id') || '';
    this.comment_id = utils.getParams('comment_id') || '';
    this.drop_top = utils.getParams('drop_top') || '';
    this.keyboardInputRef = null;
    this.updateTimeout = null;
    this.commentRef = null;
    this.inputRef = null;
    this.maskRef = null;
    // 原生键盘输入事件是否支持
    this.NativeCommentSupport = utils.SHDiffVersion(utils.getVersion(), '7.81.0');
    this.defaultAvatar = 'https://static.shihuocdn.cn/admin/imgs/20230731/78f9e02595c8ff96f1b01cbd9bcf216d_216x216.png'

    this.handleCommentPraiseClickThrottled = this.throttle(this.handleCommentPraiseClick, 500);
    this.handleReplyPraiseClickThrottled = this.throttle(this.handleReplyPraise, 500);
  }

  componentDidMount() {
    this.getCommentList();
    this.focusWebview();

    if (!this.NativeCommentSupport) {
      this.inputRef.addEventListener('focus', this.inputKeyboardFocus);
      this.inputRef.addEventListener('blur', this.inputKeyboardBlur);
    }

    // window.visualViewport.addEventListener("resize", (e) => {
    //   // 返回可视视口的顶部边缘与布局视口的顶部边缘之间的偏移量（以 CSS 像素为单位）。
    //   const keyboardHeight = window.visualViewport.offsetTop;
    // });
  }

  componentWillUnmount() {
    if (!this.NativeCommentSupport) {
      this.inputRef.removeEventListener('focus', this.inputKeyboardFocus);
      this.inputRef.removeEventListener('blur', this.inputKeyboardBlur);
    }
  }

  // 获取登录状态
  getLoginStatus = () => {
    const u = utils.getCookie("u");
    const ua = utils.getCookie("ua");
    return new Promise((resolve) => {
      Promise.all([u, ua]).then(values => {
        if (values[0] && values[1]) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

  // 登录
  handleLogin = () => {
    window.Jockey.send("action", {
      url: "shihuo://www.shihuo.cn?route=login",
    });
  }

  focusWebview() {
    if (utils.isAndroid()) {
      window.Jockey.on("focus:webview", () => {
        // 刷新秒杀状态
        this.getCommentList();
      });
    } else {
      document.addEventListener(
        "visibilitychange",
        () => {
          if (document.hidden) {
            return;
          } else {
            // 刷新秒杀状态
            this.getCommentList();
            return;
          }
        },
        false
      );
    }
  }

  inputKeyboardFocus = (e) => {
    e.preventDefault();
    this.maskRef.style.display = 'block';
    this.keyboardInputRef.style.zIndex = 2;
    this.keyboardInputRef.style.opacity = 1;
    setTimeout(() => {
      this.keyboardInputRef.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
      this.inputRef.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }, 300);
  }

  inputKeyboardBlur = () => {
    this.maskRef.style.display = 'none';
    this.keyboardInputRef.style.zIndex = -100;
    this.keyboardInputRef.style.opacity = 0;
    this.setState({
      message: ''
    });
  }

  // 评论或恢复高亮和置顶
  commentReplyHighLight() {
    const activeComment = document.querySelector(`[comment-id="${this.high_light_comment_id}"]`);
    const activeReply = document.querySelector(`[reply-id="${this.high_light_reply_id}"]`);
    let highlightElement = null, highlightType = '';
    if (activeComment && !activeReply) {
      highlightElement = activeComment;
      highlightType = 'comment';
    } else if (activeComment && activeReply) {
      highlightElement = activeReply;
      highlightType = 'reply';
    }

    if (highlightElement) {
      const offsetTop = this.commentRef.offsetTop;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });

      setTimeout(() => {
        if (highlightType === 'comment') {
          highlightElement.setAttribute('class', 'comment-wrap active');
        } else {
          highlightElement.setAttribute('class', 'reply-item active');
        }
      }, 800)
    }
  }

  getCommentList() {
    Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-behaviorapi/coupon/getComment/enter',
      method: "get",
      withCredentials: true,
      params: {
        high_light_comment_id: Number(this.high_light_comment_id),
        high_light_reply_id: Number(this.high_light_reply_id),
        extra_comment_id: Number(this.extra_comment_id),
        extra_reply_id: Number(this.extra_reply_id),
        drop_top: Number(this.drop_top),
        comment_id: this.comment_id,
        product_id: this.pageId,
        sort: '1',
        type: '22',
        page: '1',
        page_size: '2'
      },
    }).then(res => {
      const { status, data } = res.data;
      if (status === 0) {
        this.setState({
          commentData: data,
          message: ''
        }, () => {
          this.commentReplyHighLight();
        })
      }
    }).catch(() => {
      
    })
  }

  handleAwakeKeyboard = async() => {
    const loginStatus = await this.getLoginStatus();
    if (!loginStatus) {
      this.handleLogin();
      return;
    }
    if (this.NativeCommentSupport) {
      window.Jockey.send('showCommentView', {
        placeHolder: '快来讨论吧～', 
        content: '',
        emoji: this.state.commentData.emojis
      }, (payload) => {
        if (typeof payload === 'string') {
          payload = JSON.parse(payload);
        }
        this.handleAddComment(payload.content);
      })
    } else {
      this.inputRef.focus();
    }
  }

  handleEmojiClick = (e, emoji) => {
    e.preventDefault();
    this.setState({
      message: this.state.message + emoji
    });
  }

  onTextAreaChange = (e) => {
    this.setState({
      message: e.target.value
    });
  }

  handleKeyboardPress = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      if (this.state.message) {
        this.handleAddComment(this.state.message);
      } else {
        window.Jockey.send('toast', {
          text: '评论内容不能为空'
        });
      }
    }
  }

  // 发布评论
  handleAddComment = (message) => {
    if (message) {
      Request({
        url: 'https://sh-gateway.shihuo.cn/v3/apps/app_swoole_comment/addComment',
        method: 'post',
        withCredentials: true,
        data: {
          product_id: this.pageId,
          content: message,
          type: '22'
        },
      }).then(res => {
        const { status, data, msg } = res.data;
        if (status === 0) {
          const { commentData } = this.state;
          const { all_comment_href, comment_id, content, created_at, id, ip_name, is_praise, num, personal_href, praise, product_id, reply_count, reply_remain_num, self_flag, type_id, user_avatar, user_name, userid, widget } = data;
          const addComment = {
            comment_id,
            content,
            created_at,
            high_light: 0,
            id,
            ip_name,
            is_praise,
            num,
            personal_href,
            praise,
            praise_text: String(praise),
            product_id,
            reply: [],
            reply_count,
            reply_remain_num,
            self_flag,
            type_id,
            user_avatar,
            user_id: userid,
            user_name,
            widget
          }
          commentData.comment.unshift(addComment);
          commentData.all_comment_href = all_comment_href;
          this.setState({
            commentData
          }, () => {
            this.inputRef && this.inputRef.blur();
          })
        } else {
          window.Jockey.send('toast', {
            text: msg
          });
        }
      });
    }
  }

  handleCommentPraiseClick = async(comment) => {
    const loginStatus = await this.getLoginStatus();
    if (!loginStatus) {
      this.handleLogin();
      return;
    }
    const isPraise = this.handlePraiseStyle('comment', comment.comment_id, null);
    isPraise === 'false'
      ? this.handleCommentPraise(comment)
      : this.handleCommentPraiseCancel(comment)
  }

  // 评论点赞
  handleCommentPraise = (comment) => {
    Request({
      url: 'https://sh-gateway.shihuo.cn/v3/apps/app_swoole_general/commentPraise',
      method: "get",
      withCredentials: true,
      params: {
        id: this.pageId,
        comment_id: String(comment.comment_id),
        status: 1
      },
    }).then(res => {
      const { status, data, msg } = res.data;
      if (status === 0) {
      } else {
        window.Jockey.send('toast', {
          text: msg
        });
      }
    })
  }

  // 评论取消点赞
  handleCommentPraiseCancel = (comment) => {
    Request({
      url: 'https://sh-gateway.shihuo.cn/v3/apps/app_swoole_general/deleteCommentPraise',
      method: "get",
      withCredentials: true,
      params: {
        id: this.pageId,
        comment_id: String(comment.comment_id)
      },
    }).then(res => {
      const { status, data, msg } = res.data;
      if (status === 0) {
      } else {
        window.Jockey.send('toast', {
          text: msg
        });
      }
    })
  }

  // 回复点赞和取消
  handleReplyPraise = async(comment, reply) => {
    const loginStatus = await this.getLoginStatus();
    if (!loginStatus) {
      this.handleLogin();
      return;
    }
    const isPraise = this.handlePraiseStyle('reply', comment.comment_id, reply.id);
    Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-behaviorapi/app_swoole_general/reply-praise',
      method: "get",
      withCredentials: true,
      params: {
        product_id: this.pageId,
        comment_id: String(comment.comment_id),
        cluster_id: String(reply.id),
        status: isPraise === 'true' ? 2 : 1
      },
    }).then(res => {
      const { status, data, msg } = res.data;
      if (status === 0) {
      } else {
        window.Jockey.send('toast', {
          text: msg
        });
      }
    })
  }

  // 处理点赞样式
  handlePraiseStyle = (commentType = 'comment', comment_id, reply_id) => {
    let praiseTarget = null;
    if (commentType === 'comment') {
      praiseTarget = document.querySelector(`[comment-id="${comment_id}"]`);
    } else {
      praiseTarget = document.querySelector(`[reply-id="${reply_id}"]`);
    }
    let praiseNum = Number(praiseTarget.getAttribute('praise-num')) || 0;
    if (praiseNum < 0) {
      praiseNum = 0;
    }
    const isPraise = praiseTarget.getAttribute('is-praise');
    if (isPraise === 'false') {
      praiseTarget.querySelector('.has-not-praise').style.opacity = 0;
      praiseTarget.querySelector('.has-praise').style.opacity = 1;
      praiseTarget.querySelector('.praise-num').innerHTML = this.formatPraiseNum(praiseNum + 1);
      praiseTarget.querySelector('.praise-num').style.opacity = 1;
      praiseTarget.setAttribute('praise-num', praiseNum + 1);
      praiseTarget.setAttribute('is-praise', 'true');
    } else {
      praiseTarget.querySelector('.has-not-praise').style.opacity = 1;
      praiseTarget.querySelector('.has-praise').style.opacity = 0;
      praiseTarget.querySelector('.praise-num').innerHTML = praiseNum - 1 <= 0 ? 0 : this.formatPraiseNum(praiseNum - 1);
      praiseTarget.querySelector('.praise-num').style.opacity = praiseNum - 1 <= 0 ? 0 : 1;
      praiseTarget.setAttribute('praise-num', praiseNum - 1 <= 0 ? 0 : praiseNum - 1);
      praiseTarget.setAttribute('is-praise', 'false');
    }
    return isPraise;
  }

  handleJumpCommentList = (comment = {}, reply = {}, type = 'comment', all_comment_href = '') => {
    let jumpUrl = '';
    if (type === 'comment') {
      jumpUrl = `${comment.personal_href}&status=0`;
    } else if (type === 'reply') {
      jumpUrl = `${reply.personal_href}&status=1`;
    } else if (type === 'allReply') {
      jumpUrl = `${comment.personal_href}&status=2&comment_id=${comment.comment_id}`;
    } else if (type === 'allComment') {
      jumpUrl = all_comment_href;
    }
    jumpUrl && window.Jockey.send('action', {
      url: jumpUrl
    });
  }

  formatPraiseNum = (num) => {
    if (num > 9999) {
      num = parseFloat((num / 10000).toFixed(1)) + 'w';
    }
    return num;
  }

  transformEmoji = (unicode) => {
    return String.fromCodePoint(parseInt(unicode.replace("U+", ""), 16)); 
  }

  throttle = (func, delay) => {
    let inThrottle;
  
    return function(event, ...args) {
      if (!inThrottle) {
        inThrottle = true;
        func.apply(this, args);
        setTimeout(() => inThrottle = false, delay);
      }
      event.stopPropagation();
    }
  };

  // 空态
  renderEmptyState() {
    return (
      <div className="empty-state" onClick={() => this.handleAwakeKeyboard()}>
        <img src="http://static.shihuocdn.cn/admin/files/20240306/67a6ac78d31fb8f3aa4409ab30b13f92.png" alt="" />
        <p>暂时还没有评论哦<span>点击评论</span></p>
      </div>
    )
  }

  // 发送评论区域
  renderCommentInput() {
    const { user = {} } = this.state.commentData;
    return (
      <div className="coment-entry">
        <img src={user.avatar || this.defaultAvatar} alt="" className="avatar" />
        <div className="input-wrap" onClick={() => this.handleAwakeKeyboard()}>
          <img src="http://static.shihuocdn.cn/admin/files/20240307/b779cd0072f18da1ff12b64e65c61077.png" alt="" className="icon" />
          <p className="placeholder">快来讨论吧～</p>
        </div>
      </div>
    )
  }

  // 评论列表
  renderCommentList() {
    const { comment = [], all_comment_href } = this.state.commentData;
    return (
      <Fragment>
        <ul className="comment-list">
          {
            comment.slice(0, 2).map((item, index) => {
              return this.renderComment(item, index);
            })
          }
        </ul>
        <div className="all-comments" onClick={() => this.handleJumpCommentList(null, null, 'allComment', all_comment_href)}>
          全部评论
          <img src="http://static.shihuocdn.cn/admin/files/20240307/e9767a4de94e9244924f113137697b84.png" alt="" />
        </div>
      </Fragment>
    )
  }

  // 回复列表
  renderReplyList(comment = {}) {
    const { reply = [], reply_count, reply_remain_num } = comment;
    return (
      <Fragment>
        <ul className="reply-list">
          {
            reply.map((item, index) => {
              return this.renderCommentReply(item, index, comment);
            })
          }
        </ul>
        { 
          reply_remain_num > 0 && 
            <p
              className="reply-num" 
              onClick={() => this.handleJumpCommentList(comment, null, 'allReply')}
            >
              共{reply_remain_num}条回复
            </p> 
        }
      </Fragment>
    ) 
  }

  // 评论
  renderComment(item, index) {
    return (
      <li key={`comment-${index}`} className="comment-item">
        <div
          className="comment-wrap"
          comment-id={item.id}
          praise-num={item.praise}
          is-praise={item.is_praise ? 'true' : 'false'}
          onClick={() => this.handleJumpCommentList(item, null, 'comment')}
        >
          <img src={item.user_avatar || this.defaultAvatar} alt="" className="avatar" />
          <div className="info">
            <p className="username">{item.user_name}</p>
            <p className="content">{item.content}</p>
            <div className="desc">
              <span className="date">{item.created_at}</span>
              <span className="ip">{item.ip_name}</span>
              <span className="reply-btn">回复</span>
            </div>
          </div>
          <div className="praise" onClick={(event) => this.handleCommentPraiseClickThrottled(event, item)}>
            <img
              src="http://static.shihuocdn.cn/admin/files/20240417/a318772ad067b6bcbef835a68688dcc4.png"
              alt=""
              className="praise-img has-not-praise"
              style={{ opacity: item.is_praise ? 0 : 1 }}
            />
            <img
              src="http://static.shihuocdn.cn/admin/files/20240417/d745722ff745be8c2b59e5b902fb2b62.png"
              alt=""
              className="praise-img has-praise"
              style={{ opacity: item.is_praise ? 1 : 0 }}
            />
            <p className="praise-num" style={{ opacity: item.praise > 0 ? 1 : 0 }}>{item.praise_text}</p>
          </div>
        </div>
        {
          item.reply 
            && item.reply.length > 0
              && this.renderReplyList(item)
        }
      </li>
    )
  }

  // 评论回复
  renderCommentReply(item, index, comment) {
    return (
      <li
        key={`reply-${index}`}
        className="reply-item"
        reply-id={item.id}
        praise-num={item.praise}
        is-praise={item.is_praise ? 'true' : 'false'}
        onClick={() => this.handleJumpCommentList(comment, item, 'reply')}
      >
        <div className="reply-wrap">
          <img src={item.user_avatar || this.defaultAvatar} alt="" className="avatar" />
          <div className="info">
            <p className="username">{item.user_name}</p>
            <div className="content">
              { item.id ? <p className="reply-obj">回复<span className="to-username">{item.to_username}</span>：</p> : null }
              <p className="content-text">{item.content}</p>
            </div>
            <div className="desc">
              <span className="date">{item.created_at}</span>
              <span className="ip">{item.ip_name}</span>
              <span className="reply-btn">回复</span>
            </div>
          </div>
          <div className="praise" onClick={(event) => this.handleReplyPraiseClickThrottled(event, comment, item)}>
            <img
              src="http://static.shihuocdn.cn/admin/files/20240417/a318772ad067b6bcbef835a68688dcc4.png"
              alt=""
              className="praise-img has-not-praise"
              style={{ opacity: item.is_praise ? 0 : 1 }}
            />
            <img
              src="http://static.shihuocdn.cn/admin/files/20240417/d745722ff745be8c2b59e5b902fb2b62.png"
              alt=""
              className="praise-img has-praise"
              style={{ opacity: item.is_praise ? 1 : 0 }}
            />
            <p className="praise-num" style={{ opacity: item.praise > 0 ? 1 : 0 }}>{item.praise_text}</p>
          </div>
        </div>
      </li>
    )
  }

  // 自定义文本键盘输入
  renderKeyboardInput(placeholder = '快来讨论吧～') {
    let { emojis = [] } = this.state.commentData;
    emojis = emojis.map(item => this.transformEmoji(item));
    return (
      <Fragment>
        <div className="comment-mask" ref={ref => this.maskRef = ref}></div>
        <div className="keyboard-input" ref={ref => this.keyboardInputRef = ref}>
          <ul className="emojis">
            {
              emojis.map((item, index) => {
                return <li key={`emoji-${index}`} onMouseDown={(e) => this.handleEmojiClick(e, item)}>{item}</li>
              })
            }
          </ul>
          <div className="textarea-wrap">
          <textarea
            ref={ref => this.inputRef = ref}
            type="text"
            enterkeyhint="send"
            placeholder={placeholder}
            value={this.state.message}
            onChange={(e) => this.onTextAreaChange(e)}
            onKeyDown={(e) => this.handleKeyboardPress(e)}
          />
          </div>
        </div>
      </Fragment>
    )
  }

  render() {
    const { comment = [], num } = this.state.commentData;
    return (
      <div className="comment-block" ref={ref => this.commentRef = ref}>
        <div className="title">评论<span>{num > 0 ? num : ''}</span></div>
        { this.renderCommentInput() }
        { comment.length === 0 && this.renderEmptyState() }
        { comment.length > 0 && this.renderCommentList() }
        { !this.NativeCommentSupport && this.renderKeyboardInput() }
      </div>
    );
  }
}

export { PipelineComment };
export default PipelineComment;



// WEBPACK FOOTER //
// ./templates/zhuanti/src/baseComponents/comment/index.js